import React, { MutableRefObject, MouseEventHandler } from 'react';
import { DataGrid } from '../../../../libs/x-data-grid/DataGrid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ColumnMenuComponent from '../Device-telemetry/Column-menu.component';
import FooterComponent from '../Device-telemetry/Footer.component';
import VisibleMenuComponent from '../Device-telemetry/Visible-menu.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';
import { IProps as IColumnProps } from '../Device-telemetry/Column-menu.component';

const Component: React.FC<IProps> = ({
    page,
    rows,
    columns,
    lang,
    sortModel,
    limit,
    columnVisibilityModel,
    visibilitySettingsState,
    visibilitySettingsEl,
    visibilitySettingsRef,
    loading,
    onPageChange,
    onDownloadClick,
    onSortModelChange,
    onUnsort,
    onAscSort,
    onDescSort,
    onVisibilitySettingsStateChange,
    onVisibilitySettingsStateClose,
    onHideCol,
    onToggleCol,
    onShowAllCol,
    onHideAllCol,
    onLimitChange,
    onClose,
}: IProps) => {
    const getWord = useDictionary();
    const ErrorOverlay = () => {
        return (
            <Typography className="reports__no-rows-overlay">
                {getWord('error')}
            </Typography>
        );
    };
    const NoRowsOverlay = () => {
        return (
            <Typography className="reports__no-rows-overlay">
                {getWord('noData')}
            </Typography>
        );
    };
    const ColumnMenu = (
        inputProps: Pick<
            IColumnProps,
            'currentColumn' | 'disableHide' | 'hideMenu'
        >,
    ) => {
        const props = {
            ...inputProps,
            onUnsort,
            onAscSort,
            onDescSort,
            onHideCol,
        };
        return (
            <>
                <ColumnMenuComponent {...props} />
            </>
        );
    };
    const Footer = () => {
        const classes = {
            tooltipPopper: 'telemetry__tooltip-popper',
            tooltip: 'telemetry__tooltip',
            btnDownload: 'telemetry__btn_download',
            ico: 'telemetry__ico',
            btnVisibility: 'telemetry__btn_visibility',
            btnBar: 'telemetry__btn-bar',
            tablePagination: 'telemetry__table-pagination',
            tablePaginationInput: 'telemetry__table-pagination-input',
            tablePaginationInputItem: 'telemetry__table-pagination-input-item',
            tablePaginationInputTitle:
                'telemetry__table-pagination-input-title',
            tablePaginationInputWrap: 'telemetry__table-pagination-input-wrap',
            tablePaginationActions: 'telemetry__table-pagination-actions',
            tablePaginationRowsLabel: 'telemetry__table-pagination-rows-label',
            tablePaginationSelectLabel:
                'telemetry__table-pagination-select-label',
        };
        const props = {
            classes,
            lang,
            page,
            limit,
            loading: false,
            dataLength: rows.length,
            onDownloadClick,
            onVisibilitySettingsStateChange,
            onPageChange,
            onLimitChange,
        };
        return (
            <>
                <FooterComponent {...props} />
            </>
        );
    };

    return (
        <Box className="reports" component="section">
            <IconButton className="close-btn" onClick={onClose}>
                <CloseIcon className="close-btn__ico" />
            </IconButton>
            <Box className="reports__table-wrap">
                <DataGrid
                    classes={{
                        root: 'reports__table',
                        virtualScrollerRenderZone: 'reports__table-body',
                        cell: 'reports__table-cell',
                        cellContent: 'reports__table-cell-content',
                        columnHeaderTitleContainer: 'reports__table-col-header',
                        columnHeaderTitleContainerContent:
                            'reports__table-col-header-content',
                        columnHeaderTitle: 'reports__table-col-header-title',
                        virtualScroller: 'reports__table-virtual-scroller',
                    }}
                    columns={columns}
                    rows={loading ? [] : rows}
                    loading={loading}
                    pageSize={limit}
                    headerHeight={28}
                    rowHeight={28}
                    rowsPerPageOptions={[]}
                    page={page}
                    columnVisibilityModel={columnVisibilityModel}
                    sortModel={sortModel}
                    ref={visibilitySettingsRef}
                    onSortModelChange={onSortModelChange}
                    components={{
                        ErrorOverlay,
                        NoRowsOverlay,
                        ColumnMenu,
                        NoResultsOverlay: NoRowsOverlay,
                        Footer,
                    }}
                />
                <VisibleMenuComponent
                    open={visibilitySettingsState}
                    anchorEl={visibilitySettingsEl}
                    columnVisibilityModel={columnVisibilityModel}
                    onClose={onVisibilitySettingsStateClose}
                    onToggleCol={onToggleCol}
                    onShowAllCol={onShowAllCol}
                    onHideAllCol={onHideAllCol}
                />
            </Box>
        </Box>
    );
};

const ReportsComponent = React.memo(Component);

export default ReportsComponent;
